import { render } from "./SeparatorPropsCmp.vue?vue&type=template&id=4edd5f34"
import script from "./SeparatorPropsCmp.vue?vue&type=script&lang=js"
export * from "./SeparatorPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__